import {KeycloakRoleEnum} from './enums/keycloak-role.enum';

export const routeRoleConfig = {
  partner: [KeycloakRoleEnum.ADMIN],
  customer: [KeycloakRoleEnum.ADMIN, KeycloakRoleEnum.PARTNER, KeycloakRoleEnum.CUSTOMER],
  system: [KeycloakRoleEnum.ADMIN, KeycloakRoleEnum.PARTNER, KeycloakRoleEnum.CUSTOMER],
  license: [KeycloakRoleEnum.ADMIN, KeycloakRoleEnum.PARTNER, KeycloakRoleEnum.CUSTOMER],
  product: [KeycloakRoleEnum.ADMIN, KeycloakRoleEnum.PARTNER],
  tenant: [KeycloakRoleEnum.ADMIN, KeycloakRoleEnum.PARTNER, KeycloakRoleEnum.CUSTOMER],
  userMapping: [KeycloakRoleEnum.ADMIN, KeycloakRoleEnum.PARTNER, KeycloakRoleEnum.CUSTOMER],
  token: [KeycloakRoleEnum.ADMIN, KeycloakRoleEnum.PARTNER, KeycloakRoleEnum.CUSTOMER],
  appSetting: [KeycloakRoleEnum.ADMIN, KeycloakRoleEnum.PARTNER, KeycloakRoleEnum.CUSTOMER],
  userRole: [KeycloakRoleEnum.ADMIN, KeycloakRoleEnum.PARTNER, KeycloakRoleEnum.CUSTOMER],
  wizard: [KeycloakRoleEnum.ADMIN, KeycloakRoleEnum.PARTNER, KeycloakRoleEnum.CUSTOMER],
  proxy: [KeycloakRoleEnum.ADMIN],
};
